import * as React from 'react';

function SvgTotalContest(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} {...props}>
      <defs>
        <style>
          {
            '.total_contest_svg__prefix__cls-2{fill:#ffce8b}.total_contest_svg__prefix__cls-3{fill:#ffb54e}.total_contest_svg__prefix__cls-4{fill:#ff4893}.total_contest_svg__prefix__cls-6{fill:#ffc26d}.total_contest_svg__prefix__cls-7{fill:#efe2dd}'
          }
        </style>
      </defs>
      <g id="total_contest_svg__prefix__total_contest" transform="translate(-205 -444)">
        <path
          id="total_contest_svg__prefix__bound"
          fill="none"
          d="M0 0h35v35H0z"
          transform="translate(205 444)"
        />
        <g
          id="total_contest_svg__prefix__trophy_16_"
          data-name="trophy (16)"
          transform="translate(210 449.5)"
        >
          <path
            id="total_contest_svg__prefix__Path_5361"
            d="M366.46 35.82h-4.167a.86.86 0 100 1.72h4.04v5.927h-2.305a2.97 2.97 0 00-.711.086 2.9 2.9 0 00-.453.15 3 3 0 00-1.832 2.761.86.86 0 001.72 0 1.276 1.276 0 011.276-1.276h2.432a1.593 1.593 0 001.593-1.593v-6.182a1.6 1.6 0 00-1.593-1.593zm0 0"
            className="total_contest_svg__prefix__cls-2"
            data-name="Path 5361"
            transform="translate(-343.361 -33.591)"
          />
          <g
            id="total_contest_svg__prefix__Group_2339"
            data-name="Group 2339"
            transform="translate(17.67 2.229)"
          >
            <path
              id="total_contest_svg__prefix__Path_5362"
              d="M411.421 169.841v1.64a1.585 1.585 0 01-.558.1h-2.433a1.267 1.267 0 00-.711.217v-1.852a2.97 2.97 0 01.711-.086h2.305v-1.143a1.264 1.264 0 01.686 1.124zm0 0"
              className="total_contest_svg__prefix__cls-3"
              data-name="Path 5362"
              transform="translate(-405.434 -162.214)"
            />
            <path
              id="total_contest_svg__prefix__Path_5363"
              d="M370.743 35.82v1.72h-.652a.86.86 0 110-1.72zm0 0"
              className="total_contest_svg__prefix__cls-3"
              data-name="Path 5363"
              transform="translate(-368.829 -35.82)"
            />
            <path
              id="total_contest_svg__prefix__Path_5364"
              d="M362.864 196.891a7.062 7.062 0 01-1.529 3.416.855.855 0 01-.3-.655 3 3 0 011.829-2.761zm0 0"
              className="total_contest_svg__prefix__cls-3"
              data-name="Path 5364"
              transform="translate(-361.031 -189.008)"
            />
          </g>
          <path
            id="total_contest_svg__prefix__Path_5365"
            d="M423.507 188.037l-.627-.415-.626.415a.347.347 0 01-.539-.289v-7.318a.578.578 0 01.578-.578h1.175a.578.578 0 01.578.578v7.318a.347.347 0 01-.539.289zm0 0"
            className="total_contest_svg__prefix__cls-4"
            data-name="Path 5365"
            transform="translate(-401.075 -170.573)"
          />
          <path
            id="total_contest_svg__prefix__Path_5366"
            d="M12.689 43.7a2.9 2.9 0 00-.453-.15 2.97 2.97 0 00-.711-.086H9.22v-5.923h4.04a.86.86 0 100-1.72H9.093A1.6 1.6 0 007.5 37.414V43.6a1.593 1.593 0 001.593 1.593h2.432a1.276 1.276 0 011.275 1.272.86.86 0 001.72 0 3 3 0 00-1.831-2.765zm0 0"
            className="total_contest_svg__prefix__cls-2"
            data-name="Path 5366"
            transform="translate(-7.133 -33.592)"
          />
          <path
            id="total_contest_svg__prefix__Path_5367"
            d="M32.35 169.948v1.852a1.267 1.267 0 00-.711-.217h-2.433a1.585 1.585 0 01-.558-.1v-1.64a1.264 1.264 0 01.685-1.123v1.143h2.305a2.97 2.97 0 01.711.086zm0 0"
            className="total_contest_svg__prefix__cls-3"
            data-name="Path 5367"
            transform="translate(-27.246 -159.986)"
          />
          <path
            id="total_contest_svg__prefix__Path_5368"
            d="M115.364 199.652a.855.855 0 01-.3.655 7.062 7.062 0 01-1.529-3.416 3 3 0 011.829 2.761zm0 0"
            className="total_contest_svg__prefix__cls-3"
            data-name="Path 5368"
            transform="translate(-107.975 -186.779)"
          />
          <path
            id="total_contest_svg__prefix__Path_5369"
            d="M112.523 37.541h-.652V35.82h.652a.86.86 0 110 1.72zm0 0"
            className="total_contest_svg__prefix__cls-3"
            data-name="Path 5369"
            transform="translate(-106.396 -33.592)"
          />
          <path
            id="total_contest_svg__prefix__Path_5370"
            d="M43.191 188.037l.627-.415.627.415a.347.347 0 00.539-.289v-7.318a.578.578 0 00-.578-.578h-1.175a.578.578 0 00-.578.578v7.318a.347.347 0 00.538.289zm0 0"
            className="total_contest_svg__prefix__cls-4"
            data-name="Path 5370"
            transform="translate(-40.565 -170.573)"
          />
          <path
            id="total_contest_svg__prefix__Path_5371"
            fill="#ffdbaa"
            d="M138.608 8.491v7.691a6.372 6.372 0 01-5.1 6.242v3.716h-2.544v-3.716a6.372 6.372 0 01-5.1-6.242V8.491a.492.492 0 01.498-.491h11.754a.492.492 0 01.492.491zm0 0"
            data-name="Path 5371"
            transform="translate(-119.71 -7.133)"
          />
          <path
            id="total_contest_svg__prefix__Path_5372"
            d="M266.039 8.492v7.69a6.372 6.372 0 01-5.1 6.242v3.716h-1.083v-4.024a.543.543 0 01.4-.523 6.372 6.372 0 004.693-6.146V8.491a.492.492 0 00-.485-.491h1.083a.492.492 0 01.492.492zm0 0"
            className="total_contest_svg__prefix__cls-6"
            data-name="Path 5372"
            transform="translate(-247.141 -7.133)"
          />
          <path
            id="total_contest_svg__prefix__Path_5373"
            d="M230.012 343.629h2.544v1.714h-2.544zm0 0"
            className="total_contest_svg__prefix__cls-6"
            data-name="Path 5373"
            transform="translate(-218.755 -326.335)"
          />
          <path
            id="total_contest_svg__prefix__Path_5374"
            d="M148.662 358.116v3.711h-11.647v-3.711a.491.491 0 01.491-.491h10.666a.491.491 0 01.49.491zm0 0"
            className="total_contest_svg__prefix__cls-7"
            data-name="Path 5374"
            transform="translate(-130.309 -339.646)"
          />
          <path
            id="total_contest_svg__prefix__Path_5375"
            fill="#cdbfbb"
            d="M343.5 358.116v3.711h-1.129v-3.711a.491.491 0 00-.491-.491h1.129a.491.491 0 01.491.491zm0 0"
            data-name="Path 5375"
            transform="translate(-325.15 -339.646)"
          />
          <path
            id="total_contest_svg__prefix__Path_5376"
            fill="#fff5f5"
            d="M102.291 429.078H86.648a.491.491 0 01-.491-.491v-1.244a.491.491 0 01.491-.491h15.643a.491.491 0 01.491.491v1.244a.491.491 0 01-.491.491zm0 0"
            data-name="Path 5376"
            transform="translate(-81.94 -405.485)"
          />
          <path
            id="total_contest_svg__prefix__Path_5377"
            d="M395.239 427.339v1.245a.491.491 0 01-.491.491h-1.084a.491.491 0 00.491-.491v-1.245a.491.491 0 00-.491-.491h1.084a.491.491 0 01.491.491zm0 0"
            className="total_contest_svg__prefix__cls-7"
            data-name="Path 5377"
            transform="translate(-374.397 -405.481)"
          />
          <path
            id="total_contest_svg__prefix__Path_5378"
            fill="#daedff"
            d="M214.873 72.079a2.231 2.231 0 11-2.231-2.231 2.231 2.231 0 012.231 2.231zm0 0"
            data-name="Path 5378"
            transform="translate(-200.112 -65.954)"
          />
          <path
            id="total_contest_svg__prefix__Path_5379"
            fill="#b6dcff"
            d="M246.982 72.079a2.233 2.233 0 01-2.81 2.155 2.232 2.232 0 000-4.311 2.233 2.233 0 012.81 2.156zm0 0"
            data-name="Path 5379"
            transform="translate(-232.222 -65.953)"
          />
          <path
            id="total_contest_svg__prefix__Path_5380"
            d="M23.1 1.862h-3.835v-.5A.86.86 0 0018.406.5H6.652a.86.86 0 00-.859.859v.5H1.96A1.962 1.962 0 000 3.822V10a1.963 1.963 0 001.72 1.945v1.324a.367.367 0 10.734 0V9.856a.211.211 0 01.211-.211H3.84a.211.211 0 01.211.211v7.281l-.6-.395a.367.367 0 00-.406 0l-.6.395v-2.132a.367.367 0 00-.734 0v2.169a.714.714 0 001.109.6l.424-.281.424.281a.714.714 0 001.109-.6v-5.12a.911.911 0 01.516.818 1.227 1.227 0 002.238.695 6.71 6.71 0 003.351 2.017v2.028H9.871a.367.367 0 000 .734h7.99a.124.124 0 01.124.124V21H7.073v-2.53a.124.124 0 01.124-.124h.943a.367.367 0 100-.734H7.2a.859.859 0 00-.858.858V21H4.707a.859.859 0 00-.858.858V23.1a.859.859 0 00.858.858h15.644a.859.859 0 00.858-.858v-1.242a.859.859 0 00-.858-.858H18.72v-2.53a.859.859 0 00-.858-.858h-3.694v-2.028a6.71 6.71 0 003.351-2.017 1.227 1.227 0 002.238-.695.908.908 0 01.516-.819v5.12a.714.714 0 001.109.6l.424-.281.424.281a.714.714 0 001.109-.6v-5.224A1.963 1.963 0 0025.059 10V3.822a1.962 1.962 0 00-1.96-1.96zm-2.624 20V23.1a.124.124 0 01-.124.124H4.707a.124.124 0 01-.124-.124v-1.242a.124.124 0 01.124-.124h15.644a.124.124 0 01.124.124zM.734 10V3.822A1.227 1.227 0 011.96 2.6h3.833v.986H2.087a.367.367 0 00-.367.367v7.257A1.228 1.228 0 01.734 10zM3.84 8.911H2.665a.947.947 0 00-.211.024V4.316h3.339v4.733a6.665 6.665 0 00.047.787 3.325 3.325 0 00-1.115-.31.946.946 0 00-.884-.615zm2.688 4.455a.494.494 0 01-.493-.493 1.648 1.648 0 00-1.25-1.595v-1a2.6 2.6 0 011.246.546 6.757 6.757 0 00.988 2.1.494.494 0 01-.491.45zm12.495-.493a.493.493 0 01-.984.043 6.752 6.752 0 00.988-2.1 2.6 2.6 0 011.246-.546v1a1.643 1.643 0 00-1.25 1.6zm1.31-3.346a3.321 3.321 0 00-1.115.31 6.708 6.708 0 00.047-.787V7.223a.367.367 0 00-.734 0v1.826a6.017 6.017 0 01-4.8 5.882.367.367 0 00-.294.36v2.321h-1.81v-2.321a.367.367 0 00-.294-.36 6.017 6.017 0 01-4.8-5.882v-7.69a.125.125 0 01.124-.124h11.749a.125.125 0 01.124.124v4.132a.367.367 0 00.734 0V4.316H22.6v4.619a.949.949 0 00-.211-.024h-1.171a.946.946 0 00-.885.615zm2.267 7.61l-.6-.395a.367.367 0 00-.406 0l-.6.395V9.856a.211.211 0 01.211-.211h1.175a.211.211 0 01.211.211zM24.324 10a1.228 1.228 0 01-.986 1.2V3.949a.367.367 0 00-.367-.367h-3.706V2.6H23.1a1.227 1.227 0 011.226 1.226zm0 0"
            data-name="Path 5380"
          />
          <path
            id="total_contest_svg__prefix__Path_5381"
            d="M202.257 386.98a.367.367 0 000-.734H197.2a.367.367 0 000 .734zm0 0"
            data-name="Path 5381"
            transform="translate(-187.199 -366.867)"
          />
          <path
            id="total_contest_svg__prefix__Path_5382"
            d="M205.509 62.348a2.6 2.6 0 102.6 2.6 2.6 2.6 0 00-2.6-2.6zm0 4.463a1.864 1.864 0 111.864-1.864 1.866 1.866 0 01-1.864 1.863zm0 0"
            data-name="Path 5382"
            transform="translate(-192.979 -58.821)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgTotalContest;
